import type { ProductEntity } from '@/entities/assortment'
import type { ProductsQueryItemModel } from '@/shared/generated'

import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@/shared/components/ui/tabs'
import { ampli } from '@/shared/lib/ampli'

import { MarketTab } from './MarketTab'
import { PerfomanceTab } from './PerfomanceTab'
import { PriceInfoTab } from './PriceInfoTab'

export function SkuSidebarContent({
	content,
}: {
	content: ProductEntity | ProductsQueryItemModel
}) {
	const { t } = useTranslation()

	useEffect(() => {
		ampli.skuSidebarOpened()
	}, [])
	const handleTabClick = (tab: string) => {
		ampli.skuSidebarTabClicked({
			tab,
		})
	}

	return (
		<Tabs
			className='overflow-hidden px-4'
			defaultValue='price_info'
			onValueChange={handleTabClick}
		>
			<TabsList>
				<TabsTrigger value='price_info' data-tab='price_info'>
					{t('eastside_panel_tab_price_info')}
				</TabsTrigger>
				<TabsTrigger value='market' data-tab='market'>
					{t('eastside_panel_tab_market')}
				</TabsTrigger>
				<TabsTrigger value='perfomance' data-tab='perfomance'>
					{t('eastside_panel_tab_perfomance')}
				</TabsTrigger>
			</TabsList>
			<TabsContent
				value='price_info'
				className='flex flex-col overflow-x-hidden overflow-y-auto pb-10'
			>
				<PriceInfoTab content={content} />
			</TabsContent>
			<TabsContent
				value='market'
				className='flex flex-col overflow-x-hidden overflow-y-auto pb-10'
			>
				<MarketTab content={content} />
			</TabsContent>
			<TabsContent
				value='perfomance'
				className='flex flex-col overflow-x-hidden overflow-y-auto pb-10'
			>
				<PerfomanceTab content={content} />
			</TabsContent>
		</Tabs>
	)
}
